import React from 'react';
import { Typography } from 'antd';

const { Title, Text } = Typography;

// Consistent console page header: title + optional subtitle on the left, actions on
// the right. Keeps page chrome uniform across the operations console.
export const PageHeader: React.FC<{
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}> = ({ title, subtitle, actions }) => (
  <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
    <div>
      <Title level={3} style={{ marginBottom: subtitle ? 2 : 0 }}>{title}</Title>
      {subtitle && <Text type="secondary">{subtitle}</Text>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);

export default PageHeader;
